<template>
    <TheFooter>
        <div class="footer-wrapper d-flex align-items-center justify-content-between">
			<div class="footer-copyright">
			<!--footer-->
				<a href="https://www.indocyber.co.id/"></a>
				<span>&copy; {{currentYear}} {{ $footerName }}. {{version}}</span>
			</div>
			<div>
				<span class="mr-1">Powered by</span>
				<a href="https://www.indocyber.co.id/">PT Indocyber Global Teknologi</a>
			</div>
        </div>
    </TheFooter>
</template>
<script>
import { Footer as TheFooter } from '@coreui/vue'
export default {
  name: 'DefaultFooter',
  components: {
    TheFooter
  },
  data() {
	  return { 
		  hash:process.env.VUE_APP_GIT_HASH ,
		  version:localStorage.getItem("version"),
		  currentYear: new Date().getFullYear()
		} 
	}
}
</script>
